import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/DangerousGoodsDeclaration/components/SectionAbout/SectionAbout.module.scss';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  return (
    <section className={cn('about')}>
      <div className={cn('container')}>

        <div className={cn('about__description')}>
          <h2 className={cn('about__heading')}>
            What is a Dangerous Goods Declaration?
          </h2>
          <p className={cn('about__paragraph')}>
            Fundamentally, the DGD is a sworn affidavit. The shipper signs it to warrant that their goods
            meet the strict standards of the IATA DGR for air freight or the IMDG Code for ocean moves.
            This is where the shipment's specific identity is recorded, covering the UN Number, Proper
            Shipping Name, Hazard Class, and Packing Group. This is not a form to be completed by
            guesswork. It requires signature by an individual who is currently trained and certified in
            handling dangerous goods.
          </p>
          <div className={cn('about__buttons')}>
            <a
              className={cn('about__button-download-word')}
              href="/download/Resources/FreightTemplates/dangerous_goods_declaration.doc"
              target='_blank'
            >
              Download (Word)
            </a>
            <a
              className={cn('about__button-download-pdf')}
              href="/download/Resources/FreightTemplates/dangerous_goods_declaration.pdf"
              target='_blank'
            >
              Download (pdf)
            </a>
          </div>
        </div>

        {/* TODO: uncomment when picture is provided */}
        {/* <div className={cn('about__image-container')}>
          <picture>
            <source
              srcSet="/images/pages/Resources/FreightTemplates/BillOfLading/template@2x.webp 2x, 
                      /images/pages/Resources/FreightTemplates/BillOfLading/template.webp 1x"
              sizes="100vw"
            />
            <img
              className={cn('about__image')}
              src="/images/pages/Resources/FreightTemplates/BillOfLading/template.webp"
              alt="template"
            />
          </picture>
        </div> */}

      </div>
    </section>
  );
};

export default SectionAbout;